import {Component} from "@angular/core";
import {NavParams, ViewController} from "ionic-angular";

@Component({
  selector: 'popover-assinantes',
  templateUrl: 'popover-assinantes.html'
})
export class PopoverAssinantesPage {

  assinantes: Array<any>;

  constructor(public viewCtrl: ViewController,
              public navParams: NavParams) {
    this.assinantes = this.navParams.get('assinantes');
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/popovers/popover-assinantes.ts